import { AgentTaskEventSchema } from "@redotech/redo-model/agent-task-events";
import { AgentTaskRelationshipSchema } from "@redotech/redo-model/agent-task-relationships";
import {
  AgentTaskSchema,
  AgentTaskStatus,
} from "@redotech/redo-model/agent-tasks";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const searchTasksOutput_ = z.object({
  tasks: z.array(AgentTaskSchema),
  relationships: z.array(AgentTaskRelationshipSchema),
  events: z.array(AgentTaskEventSchema),
});
export const SearchTasksOutput: z.ZodType<SearchTasksOutput> =
  searchTasksOutput_;
export interface SearchTasksOutput extends z.infer<typeof searchTasksOutput_> {}

export const searchTasks = {
  name: "searchTasks" as const,
  input: z.object({
    status: createEnum(AgentTaskStatus, {
      enumName: "agent_task_status",
    }).optional(),
    labels: z.array(z.string()).optional(),
    teamId: z.string().optional(),
  }),
  output: searchTasksOutput_,
};
